import Vue from 'vue/dist/vue.esm'

Vue.component('calendars-main-vue', () => import(/* webpackChunkName: "[request]" */ 'components/calendars/Main')),
Vue.component('sofia-file-uploader-vue', () => import(/* webpackChunkName: "[request]" */ 'components/sofia/FileUploader')),
Vue.component('access-services-vue', () => import(/* webpackChunkName: "[request]" */ 'components/AccessServices'))
Vue.component('commercial-contact-form-vue', () => import(/* webpackChunkName: "[request]" */ 'components/CommercialContactForm'))
Vue.component('layout-collapsable-panel-vue', () => import(/* webpackChunkName: "[request]" */ 'components/layout/CollapsablePanel'))

import { trackButtonClickHandler } from 'common/tracking'
$(document).on(
  'click',
  '[data-track-category], [data-track-action], [data-track-name]',
  trackButtonClickHandler
)